import { render, staticRenderFns } from "./ReceiveDispatchWith1Up1Down.vue?vue&type=template&id=282571ce"
import script from "./ReceiveDispatchWith1Up1Down.vue?vue&type=script&lang=js"
export * from "./ReceiveDispatchWith1Up1Down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports